<template>
    <div>
        <hr>
        <b-message title="Logged out due to inactivity" type="is-warning" v-model="isActive" aria-close-label="Close message">
            You've been logged out due to inactivity. Please log back in to continue.
        </b-message>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isActive: true
        }
    }
}
</script>

<style scoped>
hr {
    opacity: 0%
}
</style>
